.root {
    display: flex;
    flex-direction: column;
    justify-content: center;
    grid-column: 1 / -1;
}
